import React from 'react';
import { atom } from '@reatom/framework';
import { getComponentDebugName } from '@/js/libs/reatom-devtools/index.ts';
import { createSpyContext } from './context.js';
import { createObservableFromAtom } from './observable.js';
export function useMapped$(map) {
    return React.useMemo(() => createObservableFromAtom(atom((ctx) => map(createSpyContext(ctx)), getComponentDebugName('useMapped$'))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}
